<template>
  <v-card :height="editorHeight" class="elevation-0">
    <v-card-text class="ml-0">
      <div ref="jsonView" class="vop--ace-editor"></div>
    </v-card-text>
  </v-card>
</template>

<script>
import ace from "brace"
import "brace/mode/json"
import "brace/theme/eclipse"
import "brace/ext/searchbox"
import messages from "@/XVAT/messages.json"

export default {
  name: "JSONView",
  props: ["json"],
  computed: {
    editorHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "60vh"
        case "sm":
          return "60vh"
        case "md":
          return "68vh"
        case "lg":
          return "68vh"
        case "xl":
          return "80vh"
      }
    }
  },
  watch: {
    json: {
      handler(newVal, oldVal) {
        if (newVal && oldVal !== newVal) {
          this.showJSON()
        }
      },
      deep: true
    }
  },
  data() {
    return {}
  },
  methods: {
    /**
     * openXMLEditor - Open XML Editor
     */
    showJSON() {
      let jsonString = JSON.stringify(this.json, null, "\t")
      let editor
      editor = ace.edit(this.$refs.jsonView)
      editor.setReadOnly(true)
      this.$refs.jsonView.style.backgroundColor = "floralwhite"
      editor.setTheme("ace/theme/eclipse")
      editor.getSession().setMode("ace/mode/json")
      editor.session.setValue(jsonString)
      this.$nextTick(() => {
        editor.resize(true)
      })
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
  },
  updated() { }
}
</script>
<style lang="scss" scoped>
.vop--ace-editor {
  position: absolute;
  top: 20px;
  bottom: 20px;
  left: 20px;
  right: 20px;
}

.vop--ace-editor .ace_search_field,
.ace_searchbtn:last-child {
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/XVAT/JSONView.vue